import React from 'react'

function CompFallbackLoader() {
  return (
    <div style={{ position: 'fixed', width: "100%", minHeight: "100vh", background: "url('/loader.gif')", backgroundRepeat: 'no-repeat', backgroundPosition: "center", zIndex: 999999999}} className="loader-after-dom-jq"></div>
  )
}

export default CompFallbackLoader